import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import React, { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { UkraineMap } from 'components/UkraineMap'
import { Key } from 'components/Chart_Key'
import ContentGrid from 'components/ContentGrid'
import Column from 'components/Column'
import { useEffectOnce, useWindowSize } from 'usehooks-ts'
import { Scroller } from 'components/Scroller'
import { MicroFrontendProps } from 'Types/MicroFrontendProps'
import { UkraineMapAnimated } from 'components/UkraineMapAnimated'
import { ReactVideoAndTracking } from 'components/ReactVideoAndTracking'
import { Video } from 'components/Video'

/*



*/
const Bombs = {
  february: '2022-02-01-2022-03-31.json',
  april: '2022-04-01-2022-04-30.json',
  may: '2022-05-01-2022-05-31.json',
  june: '2022-06-01-2022-06-30.json',
}
const Controlled = {
  february: '2022-03-31-ru-controlled.json',
  april: '2022-05-01-ru-cotrolled.json',
  may: '2022-05-31-ru-controlled.json',
  june: '2022-06-27-ru-controlled.json',
}
const Advances = {
  february: '2022-03-31-ru-advances.json',
  april: '2022-05-01-ru-advances.json',
  may: '2022-05-31-ru-advances.json',
  june: '2022-06-27-ru-advances.json',
}

const MapLabels: { [key: number]: MapLabelType[] } = {
  1: [
    {
      label: 'Schlangeninsel',
      pos: [30.2037, 45.2549],
      offset: 'right',
      hideLine: true
    },
  ],
  2: [
    {
      label: 'Perewalsk',
      pos: [38.8438, 48.4378],
      offset: 'top',
      hideLine: true
    },
  ],
  3: [
    {
      label: 'Melitopol',
      pos: [35.3653, 46.8489],
      offset: 'left',
      hideLine: true
    },
    {
      label: 'Stachanow',
      pos: [38.6435, 48.5682],
      offset: 'top',
    },
    {
      label: 'Schachtarsk',
      pos: [38.4383, 48.0566],
      offset: 'bottom',
    },
    {
      label: 'Altschewsk',
      pos: [38.8027, 48.4729],
      offset: 'right',
    },
  ],
  4: [
    {
      label: 'Oleniwka',
      pos: [37.6473, 47.8297],
      offset: 'top',
      hideLine: true
    },
  ],
  5: [
    {
      label: 'Briliwka',
      pos: [33.1411, 46.4203],
      offset: 'top',
      hideLine: true
    },
    {
      label: 'Stachanow',
      pos: [38.6435, 48.5682],
      offset: 'top',
      hideLine: true
    }
  ],
  6: [
    {
      label: 'Antoniwka-Brücke',
      pos: [32.720192238536015, 46.67176985045483],
      offset: 'top',
      hideLine: true
    },
  ],
  7: [
    {
      label: 'Isjum',
      pos: [37.30092307842832, 49.21839433609614],
      offset: 'bottom',
    },
    {
      label: 'Kupjansk',
      pos: [37.61258695052329, 49.71010386445633],
      offset: 'top'
    },      
  ], 

}

const bombsIdsToFilterPerStep = {
  3: [9415393, 9422462, 9416016, 9422164],
}
/*



*/
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = {
    time: 'february',
    title: 'Title from MF-Properties',
    sub: 'Mai',
  },
}): ReactElement => {
  const { width } = useWindowSize()
  const [height, setHeight] = useState(0)
  useEffectOnce(() => {
    setHeight(window.innerHeight)
  })
  const RegionsLabels: { [key: number]: RegionLabelType[] } = {
    1: [
      {
        pos: [30.2037, 45.2549],
        r: [2, 2],
      },
    ],
    2: [
      {
        pos: [38.8438, 48.4378],
        r: [2, 2],
      },
    ],
    3: [
      {
        label: 'Melitopol',
        pos: [35.3653, 46.8489],
        r: [2, 2],
      },
      {
        label: 'Stachanow',
        pos: [38.5435, 48.3182],
        r: [6, 6],
      },

    ],
    4: [
      {
        pos: [37.6473, 47.8297],
        r: [2, 2],
      },
    ],
    5: [
      {
        pos: [33.1411, 46.4203],
        r: [2, 2],
      },
      {
        pos: [38.6435, 48.5682],
        r: [2, 2],
      },
    ],
    6: [
      {
        label: 'Antoniwka-Brücke',
        pos: [32.720192238536015, 46.67176985045483],
        r: [2, 2],
      },
    ], 

  }
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  const TimeStrings = {
    february: 'Februar – März',
    april: 'April',
    may: 'Mai',
    june: 'Juni (bis zum 24.)',
  }
  const TimeStringsKey = {
    february: 'Ende März',
    april: 'Ende April',
    may: 'Ende Mai',
    june: 'am 24. Juni',
  }
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {
        <ContentGrid>
          <Column wide>
            {/* <UkraineMapAnimated /> */}
            <Scroller
              defaultDistance={height}
              front={[
                <FrontElement>
                  {/* <Title>Der gescheiterte «Enthauptungsschlag»</Title> */}
                  In den Daten von Acled finden sich bis zum 26. September
                  insgesamt 46 Ereignisse im Zusammenhang mit Himars. Diese sind
                  ziemlich sicher nicht repräsentativ – auch weil es schwierig
                  ist, Himars-Angriffe von solchen mit anderen Raketen zu
                  unterscheiden. Trotzdem belegt die Acled-Datenbank den Erfolg
                  der modernen US-Waffen exemplarisch – zumal ein Eintrag in der
                  Datenbank sehr viele Treffer beinhalten kann.
                </FrontElement>,
                <FrontElement>
                  Gemäss Acled lancieren die ukrainischen Truppen den ersten
                  Angriff mit Himars-Raketenwerfern am 20. Juni. Und zwar
                  beschiessen sie die Schlangeninsel, ein strategisch wichtiges
                  Eiland vor der Küste Odessas, welches die Russen bei
                  Kriegsbeginn besetzt haben. Am 30. Juni verlassen die Russen
                  die Insel definitiv, nachdem sie monatelang umkämpft gewesen
                  ist. Gut möglich, dass die Himars hier den Ausschlag gegeben
                  haben.
                  <br />
                  <br />
                  Allerdings sind die Treffer der Schlangeninsel umstritten. So
                  sollen die Ukrainer überhaupt erst am 23. Juni die ersten
                  Himars geliefert bekommen haben aus den USA.
                  <br />
                  <br />
                  Dieses Twitter-Video zeigt angeblich den ersten Einsatz eines
                  Himars-Raketenwerfers in der Ukraine:
                  <Video
                    filename='Schlangeninsel'
                    source='https://twitter.com/olehbatkovych/status/1540241924799463426'
                  ></Video>
                  {/* <TwitterIframe
                    data-tweet-url='https://twitter.com/olehbatkovych/status/1540241924799463426'
                    src='data:text/html;charset=utf-8,%3Cblockquote%20class%3D%22twitter-tweet%22%3E%3Cp%20lang%3D%22uk%22%20dir%3D%22ltr%22%3E%u041F%u0435%u0440%u0448%u0456%20%u0437%u0430%u043B%u043F%u0438%20%u0425%u0430%u0439%u043C%u0430%u0440%u0441%u0456%u0432%20%u043F%u043E%20%u0440%u0443%u0441%u043D%u044F%u0432%u0438%u043C%20%u043F%u043E%u0437%u0438%u0446%u0456%u044F%u043C%20%3Ca%20href%3D%22https%3A//t.co/b5hlhRUKoU%22%3Epic.twitter.com/b5hlhRUKoU%3C/a%3E%3C/p%3E%26mdash%3B%20Oleh%20Novikov%20%uD83C%uDDFA%uD83C%uDDE6%20%28@olehbatkovych%29%20%3Ca%20href%3D%22https%3A//twitter.com/olehbatkovych/status/1540241924799463426%3Fref_src%3Dtwsrc%255Etfw%22%3EJune%2024%2C%202022%3C/a%3E%3C/blockquote%3E%0A%3Cscript%20async%20src%3D%22https%3A//platform.twitter.com/widgets.js%22%20charset%3D%22utf-8%22%3E%3C/script%3E%0A'
                  ></TwitterIframe> */}
                </FrontElement>,
                <FrontElement>
                  In der Folge erhöhen die Ukrainer die Kadenz. Am 28. Juni
                  zerstören sie weit hinter der russischen Front ein
                  Munitionsdepot in <b>Perewalsk</b> in Luhansk. Es ist der
                  erste erfolgreiche Treffer dieser Art, der in den Acled-Daten
                  registriert ist. Auch da kommen Himars zum Einsatz. Die Russen
                  sowie ihre verbündeten Milizen verzeichnen hohe Verluste.
                  <br />
                  Auf diesem Twitter-Video ist die hohe Rauchsäule nach dem
                  Einschlag der Raketen in Perewalsk zu sehen:
                  <Video
                    filename='Perewalsk'
                    source='https://twitter.com/GirkinGirkin/status/1541660644079976448'
                  ></Video>
                  {/* <TwitterIframe
                    mobileHeight={720}
                    desktopHeight={938}
                    data-tweet-url='https://twitter.com/GirkinGirkin/status/1541660644079976448'
                    src='data:text/html;charset=utf-8,%3Cblockquote%20class%3D%22twitter-tweet%22%3E%3Cp%20lang%3D%22ru%22%20dir%3D%22ltr%22%3E%u041F%u0435%u0440%u0435%u0432%u0430%u043B%u044C%u0441%u043A.%20%26quot%3B...%u0432%u043E%u0435%u043D%u043D%u0430%u044F%20%u0447%u0430%u0441%u0442%u044C.%20%u043C%u043D%u043E%u0433%u043E%20%u0440%u0430%u043D%u0435%u043D%u044B%u0445%26quot%3B.%20%26quot%3B%u0442%u0440%u0435%u0432%u043E%u0436%u043D%u043E%26quot%3B%3Cbr%3E%3Cbr%3E%u0412%u0438%u043A%u0430%20%3Ca%20href%3D%22https%3A//t.co/QrTikimD4p%22%3Epic.twitter.com/QrTikimD4p%3C/a%3E%3C/p%3E%26mdash%3B%20IgorGirkin%20%28@GirkinGirkin%29%20%3Ca%20href%3D%22https%3A//twitter.com/GirkinGirkin/status/1541660644079976448%3Fref_src%3Dtwsrc%255Etfw%22%3EJune%2028%2C%202022%3C/a%3E%3C/blockquote%3E%0A%3Cscript%20async%20src%3D%22https%3A//platform.twitter.com/widgets.js%22%20charset%3D%22utf-8%22%3E%3C/script%3E%0A'
                  ></TwitterIframe> */}
                </FrontElement>,
                <FrontElement>
                  Jetzt häufen sich die Treffer: Alle paar Tage nehmen die
                  ukrainischen Truppen Munitionsdepots und Kommandostände der
                  Russen und ihrer Milizen ins Visier. Am 3. Juli ist es ein
                  Munitionsdepot in <b>Melitopol</b> im Süden der Ukraine, am 9.
                  Juli eines in <b>Stachanow</b> in der Region Luhansk und am
                  12. Juli eines in <b>Schachtarsk</b> in der Region Donezk.
                  Beim letzten Angriff sterben mehrere Mitglieder der russischen
                  Militärführung. Zuweilen feuern die Ukrainer gleich sechs
                  Raketen ab. 
                  <br />
                  <br />
                  So auch beim Treffer eines Munitionsdepots am 17.
                  Juli in <b>Altschewsk </b>
                  in der Region Luhansk.
                  <br />
                  <br />
                  Bis heute haben die Ukrainer laut eigenen Angaben mit
                  Himars-Raketenwerfern 50 Munitionsdepots der Russen und ihrer
                  Milizen zerstört.
                </FrontElement>,
                <FrontElement>
                  Dass die Russen versuchen, ihrerseits die Himars-Raketenwerfer
                  zu zerstören, liegt da auf der Hand. Anfang Juli behaupten die
                  Kremltruppen, sie hätten zwei solcher US-Geräte getroffen. Wie
                  sich später herausstellt, sind die Russen aber bloss auf
                  Himars-Holzattrappen der Ukrainer hereingefallen. Diese
                  Konstruktionen waren offenbar so gut gemacht, dass die
                  Aufklärungsdrohnen der Russen den Fake nicht erkannten. Bis
                  heute haben die Ukrainer laut eigenen Angaben keinen einzigen
                  Himars-Raketenwerfer verloren. <br /> <br />
                  Die Unwahrheit verbreiten die Russen auch im Zusammenhang mit
                  einer Explosion in einem Gefängnis bei <b> Oleniwka</b> in der Region
                  Donezk. Dabei sterben 53 ukrainische Kriegsgefangene, 73
                  werden verletzt. Die Russen behaupten, die Explosion sei durch
                  Beschuss mit Himars-Raketenwerfern verursacht worden. Wie
                  spätere Analysen zeigen, ist es jedoch wahrscheinlicher, dass
                  die Wagner-Gruppe und vermutlich auch die russische Armee
                  selber die Gebäude zerstört haben. Das ist auch die Version
                  der USA. Der Grund: Die Russen können so Kriegsverbrechen
                  vertuschen, die sie an den ukrainischen Gefangenen begangen
                  haben. 
                  <br /> 
                  Dieses Satellitenbild zeigt die Zerstörung nach der
                  Explosion beim Gefängnis in Oleniwka:
                  <ImageInText
                    src={require('assets/Sattelite_Olenivka.jpeg')}
                    alt=''
                  />
                  <Source>
                    Quelle:{' '}
                    <a href='https://twitter.com/KatiaMaruk/status/1553837572815814656'>
                      Twitter
                    </a>
                  </Source>
                </FrontElement>,
                <FrontElement>
                  Immer wieder erleiden die Russen herbe Verluste als Folge von
                  Himars-Treffern. In <b>Briliwka</b> in der Region Cherson
                  treffen die Ukrainer am 30. Juli einen Zug. Dabei sterben
                  gemäss den Acled-Daten 80 russische Soldaten, 200 werden
                  verwundet. Am 26. August zerstören die Ukrainer einen
                  Kommandoposten der Russen in <b>Stachanow</b> in der Region
                  Luhansk. Dabei sterben ungefähr 200 russische Soldaten.
                </FrontElement>,
                <FrontElement>
                  Auffallend ist, dass in den Daten von Acled kaum Einträge im
                  Süden verzeichnet sind. Das dürften Lücken sein: Denn
                  wahrscheinlich ist, dass viele Schläge auf die wichtige
                  <b> Antoniwka-Brücke</b>, die über den Dnjepr führt, und den
                  <b> Nowa-Kachowka-Staudamm</b> in der Region Cherson ebenfalls
                  mit Himars erfolgt sind. Mit Angriffen auf diese Ziele sollen
                  die dort stationierten russischen Truppen vom Nachschub
                  abgeschnitten werden. <br />
                  Anfang August berichten sogar die russischen Medien darüber.
                  Der TV-Ausschnitt zeigt das Ausmass der Zerstörung beim
                  Nowa-Kachowka-Staudamm:
                  <Video filename='Kherson' source='twitter'></Video>
                  {/* <TwitterIframe
                    mobileHeight={615}
                    desktopHeight={661}
                    data-tweet-url='https://twitter.com/UAWeapons/status/1557384679166283779'
                    src='data:text/html;charset=utf-8,%3Cblockquote%20class%3D%22twitter-tweet%22%3E%3Cp%20lang%3D%22en%22%20dir%3D%22ltr%22%3E%3Ca%20href%3D%22https%3A//twitter.com/hashtag/Ukraine%3Fsrc%3Dhash%26amp%3Bref_src%3Dtwsrc%255Etfw%22%3E%23Ukraine%3C/a%3E%3A%20Russian%20media%20showed%20the%20aftermath%20of%20precise%20Ukrainian%20HIMARS%20strikes%20on%20the%20Kakhovka%20Dam%2C%20%3Ca%20href%3D%22https%3A//twitter.com/hashtag/Kherson%3Fsrc%3Dhash%26amp%3Bref_src%3Dtwsrc%255Etfw%22%3E%23Kherson%3C/a%3E%20Oblast%20-%20and%20accidentally%20revealed%20destroyed%20Russian%20military%20equipment%20placed%20there%2C%20including%20a%20valuable%20R-439-MD2%20satcom%20vehicle%20and%205%20KAMAZ-based%20vehicles.%20%3Ca%20href%3D%22https%3A//t.co/HrrHOTP97F%22%3Epic.twitter.com/HrrHOTP97F%3C/a%3E%3C/p%3E%26mdash%3B%20%uD83C%uDDFA%uD83C%uDDE6%20Ukraine%20Weapons%20Tracker%20%28@UAWeapons%29%20%3Ca%20href%3D%22https%3A//twitter.com/UAWeapons/status/1557384679166283779%3Fref_src%3Dtwsrc%255Etfw%22%3EAugust%2010%2C%202022%3C/a%3E%3C/blockquote%3E%0A%3Cscript%20async%20src%3D%22https%3A//platform.twitter.com/widgets.js%22%20charset%3D%22utf-8%22%3E%3C/script%3E%0A'
                  ></TwitterIframe> */}
                </FrontElement>,
                <FrontElement>
                  Am 6. September startet die ukrainische Armee die
                  Blitzoffensive im Nordosten des Landes. Unter anderem befreit
                  sie die strategisch wichtigen Städte <b>Isjum</b> und{' '}
                  <b>Kupjansk</b>. Innert weniger Tage holt sie ein Gebiet von
                  6000 bis 9000 Quadratkilometern zurück. Die russischen
                  Soldaten flüchten in Panik – und lassen viel Kriegsgerät
                  zurück. <br />
                  Den Boden bereitet für diesen Gegenschlag haben die
                  zahlreichen Himars-Treffer. Bis zum Beginn der Gegenoffensive
                  haben die Ukrainer mit den Himars laut dem US-Generalstabschef
                  Mark Milley bereits mehr als 400 Ziele der Russen getroffen.
                </FrontElement>,
              ]}
              back={(index) => {
                let time = 'none'
                let step = 0
                let showlabel = true
                if (index <= 3) {
                  time = 'february'
                } else if (index <= 7) {
                  time = 'april'
                }
                if (index <= 3) {
                  step = index - 1
                  if (index > 0) showlabel = true
                } else if (index <= 7) {
                  step = index - 5
                  if (index > 4) showlabel = true
                } else if (index <= 11) {
                  time = 'may'
                  step = index - 9
                  if (index > 8) showlabel = true
                } else if (index > 11) {
                  time = 'june'
                  step = index - 13
                  if (index > 12) showlabel = true
                }
                // console.log(index, time, step)
                let bombs = require('../GeoJSON/2022-02-01-2022-09-26-UkraineHIMARS.json')
                // console.log(bombs)

                // index === 16
                //   ? require('../GeoJSON/civilbuildings.json')
                //   : require('../GeoJSON/' + Bombs[time])
                return (
                  <>
                    <Column style={{ height: height + 'px' }}>
                      <MapWrapper className='MapWrapper'>
                        {/* <Time> */}
                          {/* {index} */}
                          {/* {index === 16 ? 'Februar – Juni' : TimeStrings[time]} */}
                        {/* </Time> */}
                        {bombs && (
                          <UkraineMap
                            height={height}
                            zoomToRegionLabels={
                              index === 3
                              // index >= 1 && index < 7
                            }
                            data={
                              bombs
                              // bombsIdsToFilterPerStep[index]
                              //   ? {
                              //       ...bombs,
                              //       features: bombs.features.filter((bomb) =>
                              //         bombsIdsToFilterPerStep[index].includes(
                              //           bomb.properties.data_id
                              //         )
                              //       ),
                              //     }
                              //   : bombs
                            }
                            russianControl={
                              // index !== 16 &&
                              // require('../GeoJSON/' + Controlled[time])
                              require('../GeoJSON/2022-09-21-ru-controlled.json')
                            }
                            russianAdvance={
                              index >= 7 &&
                              require('../GeoJSON/Ruekschlag.json')
                            }
                            regionLabels={
                              RegionsLabels?.[index]
                            }
                            mapLabels={MapLabels[index]}
                            colorMode={colorMode}
                            index={index}
                          />
                        )}
                        {bombs && (
                          <KeyWrapper>
                            {/* <Key
                              entries={
                                index === 16
                                  ? [
                                      {
                                        type: 'cross',
                                        label: (
                                          <>
                                            Beschädigte oder zerstörte Schulen,
                                            Kranken&shy;häuser und Kindergärten
                                          </>
                                        ),
                                        color: '#D3343F',
                                      },
                                    ]
                                  : [
                                      {
                                        type: 'circle',
                                        label:
                                          'Artillerie, Raketen (' +
                                          bombs.features.filter(
                                            (f: {
                                              properties: { event: string }
                                            }) =>
                                              !f.properties.event
                                                .toLowerCase()
                                                .includes('air')
                                          ).length +
                                          ')',
                                        color:
                                          colorMode === 'light'
                                            ? '#E16D00'
                                            : '#E16D00',
                                      },
                                      {
                                        type: 'circle',
                                        label:
                                          'Luftschläge (' +
                                          bombs.features.filter(
                                            (f: {
                                              properties: { event: string }
                                            }) =>
                                              f.properties.event
                                                .toLowerCase()
                                                .includes('air')
                                          ).length +
                                          ')',
                                        color:
                                          colorMode === 'light'
                                            ? '#202346'
                                            : '#378EBD',
                                      },
                                      {
                                        type: 'rect',
                                        label: (
                                          <>
                                            Von Russland kontrollierte Gebiete{' '}
                                            <span>{TimeStringsKey[time]}</span>
                                          </>
                                        ),
                                        color:
                                          colorMode === 'light'
                                            ? '#C8C8D1'
                                            : 'rgba(239, 236, 224,.4)',
                                      },
                                      {
                                        type: 'rect-pattern',
                                        label: (
                                          <>
                                            Russische Vorstösse{' '}
                                            <span>{TimeStringsKey[time]}</span>
                                          </>
                                        ),
                                        color:
                                          colorMode === 'light'
                                            ? '#C8C8D1'
                                            : 'rgba(239, 236, 224,.4)',
                                      },
                                    ]
                              }
                            /> */}

                            <Source>
                            Frontverlauf vom { index >= 7 &&  "5. und "}26.September
                            <br />
                              Quelle:{' '}
                              <a
                                href='https://acleddata.com/ukraine-crisis/'
                                target={width < 712 ? '_self' : '_blank'}
                              >
                                ACLED
                              </a>
                              ,{' '}
                              <a
                                href='https://www.understandingwar.org/'
                                target={width < 712 ? '_self' : '_blank'}
                              >
                                ISW
                              </a>
                            </Source>
                          </KeyWrapper>
                        )}
                      </MapWrapper>
                    </Column>
                  </>
                )
              }}
            />
          </Column>
        </ContentGrid>
      }
    </AppContainer>
  )
}

const FrontElement = styled.div<{ distance?: number }>`
  text-align: left;
  background-color: var(--site-background);
  color: var(--text-color);
  font-size: 18px;
  padding: 30px;
  border-radius: 2px;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-serif);
  line-height: 3rem;
  max-width: 606px;
  -webkit-box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.3),
    0px 0px 9px -1px rgba(255, 255, 255, 0.3);
  box-shadow: 0px 0px 9px -1px rgba(0, 0, 0, 0.3),
    0px 0px 9px -1px rgba(255, 255, 255, 0.3);

  &.high {
    margin-top: 300px;
  }
  @media only screen and (max-width: 711px) {
    max-width: calc(100% + 1rem);
    width: calc(100% + 1rem);
    padding-right: 2rem;
    margin-left: -2rem;
    padding-left: 15px;
    padding-right: 15px;
  }
`

const Title = styled.div`
  font-family: var(--font-serif);
  font-size: 26px;
  color: var(--text-color);
  font-weight: 700;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 10px;
`

const KeyWrapper = styled.div`
  max-width: 666px;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
  flex: 0 0 10%;
`
const AttackCounter = ({
  air,
  artillery,
  colorMode,
}: {
  air: number
  artillery: number
  colorMode: 'light' | 'dark'
}) => {
  return (
    <StyledAttackCounter>
      <AttackElement>
        <div className='icon'>
          <img
            src={require(colorMode === 'light'
              ? '../../assets/icons_artillery.png'
              : '../../assets/icons_artillery_dm.png')}
          />
        </div>
        <div className='value'> {artillery}</div>
        <div className='label'>Artillerie-, Raketenangriffe</div>
      </AttackElement>
      <AttackElement>
        <div className='icon'>
          <img
            src={require(colorMode === 'light'
              ? '../../assets/icons_air.png'
              : '../../assets/icons_air_dm.png')}
          />
        </div>
        <div className='value'>{air}</div>
        <div className='label'>Luftangriffe</div>
      </AttackElement>{' '}
    </StyledAttackCounter>
  )
}

const ImageInText = styled.img`
  width: 100%;
  margin-top: 1em;
`
const TwitterIframe = styled.iframe<{
  mobileHeight?: number
  desktopHeight?: number
}>`
  width: 100%;
  height: ${(props) => props.desktopHeight ?? '550'}px;
  border: none;
  @media only screen and (max-width: 711px) {
    height: ${(props) => props.mobileHeight ?? '435'}px;
  }
`

const StyledAttackCounter = styled.div`
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  font-family: var(--font-sans-serif);
  margin-bottom: 2em;
  color: var(--text-color);
  border-top: 1px solid #c8c8d1;
  padding-top: 2em;
  @media only screen and (max-width: 711px) {
    width: 100%;
  }
`
const StyledBuildingCounter = styled.div`
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  font-family: var(--font-sans-serif);
  margin-bottom: 2em;
  color: var(--text-color);
  padding-top: 2em;
  @media only screen and (max-width: 711px) {
    width: 100%;
  }
`
const BuildingText = styled.div`
  flex: 0 0 100%;
  text-align: center;
  &.top {
    padding-bottom: 30px;
  }
  &.bottom {
    padding-top: 30px;
  }
`
const AttackElement = styled.div`
  flex: 0 0 50%;
  text-align: center;
  .icon {
    line-height: 0;
    img {
      max-width: 80px;
    }
  }
  .value {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5em;
  }
  .label {
    font-size: 15px;
    line-height: 1.2em;
  }
`
const BuildingElement = styled.div`
  flex: 0 0 33%;
  text-align: center;
  .icon {
    line-height: 0;
    img {
      max-width: 100px;
      margin-bottom: 0.25em;
      @media only screen and (max-width: 711px) {
        max-width: 80px;
      }
    }
  }
  .value {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5em;
  }
  .label {
    line-height: 1.2em;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
    }
  }
`
const OrangeMarker = styled.div<{ colorMode: 'light' | 'dark' }>`
  display: inline-block;
  width: 0.7em;
  height: 0.75em;
  border-radius: 0.75em;
  margin-left: 0.1em;
  margin-right: 0.1em;
  background-color: ${({ colorMode }) =>
    colorMode === 'light' ? '#e16d00' : '#e16d00'};
`
const BlueMarker = styled.div<{ colorMode: 'light' | 'dark' }>`
  display: inline-block;
  width: 0.75em;
  height: 0.75em;
  background-color: ${({ colorMode }) =>
    colorMode === 'light' ? '#202346' : '#69aacd'};
  border-radius: 0.75em;
  margin-left: 0.1em;
  margin-right: 0.1em;
`

const Time = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 26px;
  color: var(--text-color);
  font-weight: 300;
  padding-bottom: 2em;

  width: 100%;
  text-align: center;
  flex: 0 0 15%;
  @media only screen and (max-width: 711px) {
    font-size: 24px;
    padding-top: 30px;
  }
`
const TimeTitle = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 22px;
  color: var(--text-color);
  font-weight: 300;
  padding-bottom: 1em;
  font-family: var(--font-sans-serif);

  width: 100%;
  text-align: center;
  flex: 0 0 10%;
  @media only screen and (max-width: 711px) {
    font-size: 20px;
  }
`
const Source = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  color: var(--gray-3);
  a {
    color: var(--blue-main);
    text-decoration: none;
  }
`
const MapWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (max-width: 711px) {
    /* width: 118%;
    margin-left: -9%; */
    max-width: 100vw;
    overflow: hidden;
    margin-left: -2rem;
    max-width: calc(100% + 4rem);
    width: calc(100% + 4rem);
  }
`
const AppContainer = styled(TamediaStyles)<{
  tenant?: string
}>`
  width: 100%;

  margin: 0;
  margin-top: 60px;
  margin-bottom: 60px;
  padding: 0;

  font-family: var(--font-sans-serif);
  color: var(--brandblue-main);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--site-background);
  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export default MainComponent
